import { memo } from "react";

const ActionDownload = (props: any) => (
  <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.7634 5.67595L7.99997 10.44L3.23642 5.67643L3.28619 5.62662L6.88675 9.22658L7.96496 10.3046V8.77992V1.96487H8.03505V8.78125V10.3063L9.11333 9.22784L12.714 5.62654L12.7634 5.67595ZM13.3684 13.2982V13.3683H2.63162V13.2982H13.3684Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.26324"
    />
  </svg>
);

export default memo(ActionDownload);
